import { type PrivateNumberFilters } from '@reliance/types/filters/PrivateNumberFilters';
import { type PrivateNumber } from '@reliance/types/models/PrivateNumber';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiSuccessResponse, type ApiService } from '../types/ApiService';

export type PrivateNumberCreateRequest = {
  ani: string;
  name: string;
  addedByName: string;
  facilityId?: number;
};

export type PrivateNumberDeleteParams = {
  removedByName: string;
};

export const privateNumber = (centralApi: ApiService) => ({
  post: (
    data: PrivateNumberCreateRequest,
  ): Promise<ApiSuccessResponse<void>> => {
    return centralApi.post('/private-number', data);
  },
  delete: (
    id: number,
    data: PrivateNumberDeleteParams,
  ): Promise<ApiSuccessResponse<void>> => {
    return centralApi.delete(`/private-number/${id}`, { params: data });
  },
  index: (
    filters?: Partial<PrivateNumberFilters>,
  ): Promise<PaginatedResponse<PrivateNumber>> => {
    return centralApi.get('/private-number', { params: filters });
  },
});
